exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SettingsModal-module__wrapper___1lKCN img{max-width:200px;margin:0 auto 1rem;display:flex;justify-content:center}.SettingsModal-module__wrapper___1lKCN h2{margin-bottom:1rem}.SettingsModal-module__wrapper___1lKCN strong{display:block}.SettingsModal-module__wrapper___1lKCN p{margin-bottom:.75rem}.SettingsModal-module__wrapper___1lKCN p a{color:#0827e9;cursor:pointer}.SettingsModal-module__wrapper___1lKCN .SettingsModal-module__dropdown___2dXPD{max-width:250px}.SettingsModal-module__wrapper___1lKCN .SettingsModal-module__button-wrapper___1RgSx{margin-top:2rem;display:grid;grid-auto-flow:column;gap:.5rem;justify-content:end}", ""]);

// exports
exports.locals = {
	"wrapper": "SettingsModal-module__wrapper___1lKCN",
	"dropdown": "SettingsModal-module__dropdown___2dXPD",
	"button-wrapper": "SettingsModal-module__button-wrapper___1RgSx"
};